import Layer from 'ol/layer/Layer'
import Vue from 'vue'
// import { instanceOf } from '../util/assert'

const methods = {
  /**
   * @return {IndexedCollectionAdapter}
   * @protected
   */
  getLayersTarget () {
    throw new Error('Not implemented method')
  },
  /**
   * @param {ol.layer.Layer|Vue} layer
   * @return {void}
   */
  addLayer (layer) {
    // console.log("Adding layer")
    layer = layer instanceof Vue ? layer.$layer : layer
    // instanceOf(layer, Layer)

    if (this.getLayersTarget().has(layer) === false) {
      // console.log("Adding layer")
      this.getLayersTarget().add(layer)
    }
  },

  addVueLayer (layer) {
    this._vueLayers.push(layer)
  },

  getVueLayers() {
    return this._vueLayers
  },
  getEmptyLayer() {
    return this._emptyLayer
  },
  /**
   * @param {ol.layer.Layer|Vue} layer
   * @return {void}
   */
  removeLayer (layer) {
    layer = layer instanceof Vue ? layer.$layer : layer

    if (!layer) return

    if (this.getLayersTarget().has(layer)) {
      this.getLayersTarget().remove(layer)
    }
  },
  /**
   * @return {ol.layer.Layer[]}
   */
  getLayers () {
    return this.getLayersTarget().elements
  },
  /**
   * @param {string|number} id
   * @return {ol.layer.Layer|undefined}
   */
  getLayerById (id) {
    return this.getLayersTarget().findByKey(id)
  },
  /**
   * @return {void}
   */
  clearLayers () {
    this.getLayersTarget().clear()
  },
  /**
   * @returns {Object}
   * @protected
   */
  getServices () {
    // console.log("layersContainer services")
    const vm = this

    return {
      get layersContainer () { return vm },
      // get layers () { return vm.$layers }
    }
  },
}

export default {
  methods,
  created () {
    this._vueLayers = []
    this._emptyLayer = undefined
  },
  destroyed () {
    this.clearLayers()
  },
}


// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/mixins/containers/layers-container.js